<div class="info-list has-info-icon py-3" [ngClass]="{ freemium: isFreemium }">
  <app-app-info-list-item [label]="'Domain Age'"
                          [type]="'text-risk'"
                          [text]="data?.riskOverview?.whoisInfo?.domainAge + ' years'"
                          [value]="data?.riskOverview?.domainAgeRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Privacy Policy Detected'"
                          [type]="'yesno'"
                          [value]="data?.riskOverview?.hasPrivacyLink"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Terms and Conditions Detected'"
                          [type]="'yesno'"
                          [value]="data?.riskOverview?.hasTermsOfServiceLink"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'WHOIS Info Hidden'"
                          [tooltipText]="'Private Domains are those that are registered as anonymous in the Whois site registration data'"
                          [type]="'yesnorev'"
                          [value]="data?.riskOverview?.isPrivateDomain === 'true'"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Corporate Email'"
                          [tooltipText]="'True means Whois registration was done with a corporate email address; False means Whois registration was done with a personal email address'"
                          [type]="'yesno'"
                          [value]="data?.riskOverview?.isCorporateEmail === 'true'"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Ad Injection'"
                          [type]="'yesno'"
                          [value]="data?.riskOverview?.adInjectionRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
</div>
